export const HSP_NAME_CODE = {
  13: 'dsmc',
  5: 'hyumc',
  6: 'hyumc-guri',
};
